import { useQuery } from "../query";
import { getUserDesignTokensOnly } from "../HelperFunction/HelperFunction";
import { supabase } from "../../config/supabaseClient";
import { writeCachedUserDesignTokens } from "../designTokensCache";

/**
 * Always fetches fresh design columns from `user`.
 * localStorage cache is written on success but never used as query initialData —
 * consumers read cache separately for first-paint hydration only.
 */
export function useUserDesignTokens(username: string | null | undefined) {
  return useQuery(
    ["userDesignTokens", username],
    async ({ signal }: { signal?: AbortSignal }) => {
      return getUserDesignTokensOnly(username!, supabase, signal);
    },
    {
      enabled: Boolean(username),
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        if (username && data) writeCachedUserDesignTokens(username, data);
      },
    },
  );
}
